import { render, staticRenderFns } from "./VoucherView.vue?vue&type=template&id=6b134302&scoped=true&"
import script from "./VoucherView.vue?vue&type=script&lang=js&"
export * from "./VoucherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b134302",
  null
  
)

export default component.exports